<template>
    <div class="home">
        <Header />
        <div id="outerContainer">
            <div id="clippingBounds1" style="width:auto" ref="clippingBounds1">
                <!-- <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" />
                </keep-alive>
                <router-view v-if="!$route.meta.keepAlive"></router-view> -->
                <router-view />
                <!-- <Footer /> -->
            </div>

        </div>
        <template v-if="$route.path === '/dashboard/cedoc/index'
        || $route.path === '/dashboard/classify/index'
        || $route.path === '/dashboard/field/index'
        || $route.path === '/dashboard/template/index'
        || $route.path === '/dashboard/templateCommunity'">
            <moveIcon ref="moveIcon" @showRight="showRight = true">
            </moveIcon>
            <div class="right-div" v-if="showRight" @click="$refs.moveIcon.drawer = true;">
                <a>新手教程</a>
                <i class="el-icon-caret-left" @click="$refs.moveIcon.drawer = true"></i>
                <i class="el-icon-close" @click.stop="showRight = false"></i>
            </div>
        </template>
    </div>
</template>
<script>
    import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
    import moveIcon from '@/components/common/moveIcon'
    // @ is an alias to /src
    import Header from '@/components/header/Header.vue'
    import Footer from '@/components/header/Footer.vue'

    export default {
        name: 'home',
        data() {
            return {
                showRight: false
            }
        },
        computed: {},
        components: {
            Header,
            Footer,
            moveIcon
        },
        watch: {
            $route: function (to, from) {
                document.querySelector('#outerContainer').scrollTop = 0
            }
        },
        mounted() {
            //console.log(this.$route)
            let bodyHeight = document.documentElement.clientHeight
            let clip = document.getElementById('clippingBounds1')
            if (clip) {
                clip.style.height = bodyHeight - 51 + 'px'
            }
            window.onresize = () => {
                let bodyHeight = document.documentElement.clientHeight
                let clip = document.getElementById('clippingBounds1')
                if (clip) {
                    clip.style.height = bodyHeight - 51 + 'px'
                }
            }
        },
        methods: {}
    }
</script>
<style>
    @import "../../assets/css/common/variables.css";

    #outerContainer {
        padding-left: 0;
        overflow: scroll;
    }

    #sitemapHost {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 168px;
        z-index: 2;
        position: absolute;
        left: 0;
        top: 0;

        ul {
            li {
                height: 80px;
                line-height: 80px;
                text-align: center;

                a {
                    display: block;
                    height: 80px;
                    line-height: 80px;
                    color: var(--color-title);
                    text-decoration: none;
                }

                i {
                    margin-right: 18px;
                }

                .router-link-active {
                    background: var(--color-title);

                    color: #ffffff;

                    i {
                        color: #ffffff;
                    }
                }
            }
        }
    }

    .leftPanel,
    .rightPanel,
    .mobileOnlyPanel {
        position: relative;
        background-color: #f2f2f2;
        overflow: hidden;
        width: 0px;
        flex-shrink: 0;
    }

    .leftPanel {
        box-shadow: 2px 0 6px 0 rgba(0, 58, 113, 0.35);
        background: #fff;

        .site {
            background: #fff;
            text-align: center;
        }
    }

    #clippingBounds1 {

        /*background: #f0f2f5;*/
        .bread {
            height: 45px;
            line-height: 45px;
            background: #fff;
            text-align: left;
            padding-left: 26px;
            overflow: hidden;
            border-bottom: 1px solid #e8e8e8;
            z-index: 1;
            display: flex;
            align-items: center;
            margin: 12px 24px 0 24px;
            position: relative;
            flex-shrink: 0;

            h6 {
                font-size: 12px;
                color: #bfbfbf;
                margin-left: 22px;
            }

            h1 {
                color: #aaaaaa;
                font-size: 16px;
                font-weight: normal;
                position: relative;

                a {
                    color: #aaaaaa;
                }
            }

            h1.active {
                color: var(--color-title);
                font-size: 16px;
                font-weight: bold;

                a {
                    color: var(--color-title);
                }

                span {
                    position: absolute;
                    width: 65px;
                    height: 3px;
                    background: var(--color-title);
                    left: 0;
                    bottom: 0;
                }
            }

            h1:nth-child(2),
            h1:nth-child(3) {
                margin-left: 30px;
            }

            h2 {
                font-size: 16px;
                color: #000000;

                a {
                    color: #aaaaaa;
                    font-size: 14px;
                }
            }

            .back {
                position: absolute;
                right: 20px;
                top: 8px;
                font-size: 14px;
                /* color: var(--color-title); */
                text-align: center;
                /*font-weight: bold;*/
                cursor: pointer;
                /* border: 1px solid var(--color-title); */
                background: #fff;
                border-radius: 5px;
                padding: 5px 13px;

                h3 {
                    line-height: 1;
                }
            }
        }

        .imageIdentify {
            height: 100%;
            overflow: hidden;

            .top {
                height: 62px;
                line-height: 62px;
                background: #fff;
                border-bottom: 1px solid #e8e8e8;
                display: flex;
                align-items: center;
                padding-left: 26px;

                #inputName {
                    font-size: 16px;
                    color: var(--color-d4);

                    .name {
                        font-size: 14px;
                        cursor: pointer;
                    }

                    .name:before {
                        content: "*";
                        color: #f56c6c;
                        margin-right: 4px;
                    }
                }
            }

            .contentBill {
                padding: 0 26px 9px 26px;
                display: flex;
                align-items: center;
                height: calc(100% - 95px);
                margin-top: 20px;

                .upload-demo {
                    .el-upload-list {
                        display: none;
                    }
                }

                .toTest {
                    position: absolute;
                    top: 14px;
                    right: 25px;
                }

                .left {
                    /*/* width: calc(100% - 7px); */
                    height: calc(100% - 2px);
                    background: #fff;
                    border: 1px solid #eee;
                    position: relative;
                    /*margin-right: 24px;*/
                    overflow: hidden;
                    margin-top: -1px;
                    margin-right: 1px;

                    .pageImage {
                        position: absolute;
                        right: 10px;
                        top: 13px;
                        z-index: 1;
                        color: var(--color-d4);
                    }
                }

                .bl-drag .ui-draggable {
                    top: -55px;
                    height: 126%;
                }

                .right.doc-set {
                    height: calc(100% - 60px) !important;
                }

                .right {
                    padding-right: 0;
                    height: calc(100%);
                    /*overflow: auto;*/
                    flex: 2;
                    font-size: 14px;
                    /* border-right: 1px solid #eee; */

                    /*width: 400px;*/
                    /*padding-right: 4px;*/
                    /*border-left: 1px solid #efefef;*/
                    .tabsTop {
                        .el-tabs__header {
                            margin: 0 0 5px 0;
                        }

                        .el-tabs__item {
                            height: 37px;
                            line-height: 38px;
                        }

                        .el-tabs__nav-wrap {
                            padding-left: 30px;
                        }

                        .el-tabs__nav-wrap::after {
                            height: 1px;
                        }

                        .el-tabs__nav-scroll {}
                    }

                    .el-form-item__label {
                        font-size: 14px;
                        text-align: left;
                        line-height: 36px;
                    }

                    .footer {
                        text-align: right;
                        bottom: -50px;
                        background: #fff;
                        z-index: 1024;
                        left: 50%;
                        position: absolute;
                        padding: 17px 20px;
                        width: calc(100% - 42px - 4px);
                        margin-left: calc(-50%);
                        white-space: nowrap;

                        .el-button {
                            padding: 8px 26px;
                        }

                        .el-button+.el-button {
                            margin-left: 20px;
                        }

                        .delteFile {
                            padding: 8px 16px;
                        }
                    }

                    .el-select {
                        .el-input__inner {
                            height: 36px;
                            line-height: 36px;
                        }

                        .el-input__icon {
                            line-height: 30px;
                            /*display: none;*/
                        }
                    }

                    .el-select-dropdown {}
                }

                .savefooter {
                    text-align: right;
                    padding: 20px;

                    .el-button--primary {
                        font-size: 14px;
                        color: #fff;
                        width: 80px;
                        height: 42px;
                        line-height: 42px;
                        padding: 0;
                        border-radius: 4px;
                        font-weight: normal;
                        background: var(--color-title);
                    }
                }
            }
        }
    }

    @keyframes leftPanel-in {
        from {
            left: -168px;
        }

        to {
            left: 0px;
        }
    }

    @keyframes leftPanel-out {
        from {
            left: 0px;
        }

        to {
            left: -168px;
        }
    }

    @keyframes out-in {
        from {
            padding-left: 0;
        }

        to {
            padding-left: 168px;
        }
    }

    @keyframes out-out {
        from {
            padding-left: 168px;
        }

        to {
            padding-left: 0;
        }
    }

    .leftPanel.config-fadeIn {
        animation: leftPanel-in 0.2s;
        animation-fill-mode: forwards;
    }

    .leftPanel.config-fadeOut {
        animation: leftPanel-out 0.2s;
        animation-fill-mode: forwards;
    }

    #outerContainer {
        background-color: #f2f2f2;
        box-shadow: inset 0px 2px 10px rgb(0 58 113 / 21%);
    }

    #outerContainer.config-fadeIn {
        animation: out-in 0.2s;
        animation-fill-mode: forwards;

        .bread {
            left: 168px;
        }
    }

    #outerContainer.config-fadeOut {
        animation: out-out 0.2s;
        animation-fill-mode: forwards;

        .bread {
            left: 0;
        }
    }

    .right-div {
        position: fixed;
        right: 0;
        top: 0;
        width: 30px;
        height: 100%;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        cursor: pointer;

        &:hover {
            i.el-icon-close {
                display: block !important;
                color: #3D7FFF;
            }

            i {
                color: #3D7FFF;
            }
        }

        a {
            position: absolute;
            top: 15%;
            left: 50%;
            margin: auto;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            line-height: 26px;
            font-size: 14px;
            color: #666;
        }

        i {
            font-size: 22px;
            position: absolute;
            top: 50%;
            left: 50%;
            margin: auto;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            color: #ddd;
        }

        i.el-icon-close {
            font-size: 18px;
            position: absolute;
            top: 3%;
            left: 50%;
            margin: auto;
            -webkit-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
            color: #ddd;
        }
    }
</style>